export default "__VITE_ASSET__RyEJzmDe__"